import { Component, OnInit, Input, ContentChild, TemplateRef, EventEmitter, Output, OnChanges, SimpleChanges, SimpleChange, ElementRef, ViewEncapsulation } from '@angular/core';
import { Product } from '../../api/models/product-alias';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { BomTableRow } from '../../api/models/bom-table-row';
import { BomLine, BomLineInput, BomLinesRequest } from '../../api/models/bom-line';
import { BomTableService } from './bom-table.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CutCableModalComponent } from '../cut-cable-modal/cut-cable-modal.component';
import { AuthService } from '../../api/services/auth.service';
import { ProjectService } from '../../api/services/project.services';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs/Subject';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { PurchasePlan } from '../../api/models/purchase-plan';
import { Worksheet } from '../../api/models/worksheet';
import { OrderSimulation, OrderLines, ShippingAndHandling } from '../../api/models/order-simulation';
import { ProductAliasService } from '../../api/services/product-alias.service';
import { BomCsvUploadErrorComponent } from './bom-csv-upload-error/bom-csv-upload-error.component';
import { OrderDetail } from '../../api/models/order-detail';
import { DeleteModalComponent } from '../delete-modal/delete-modal.component';

@Component({
  selector: 'app-bom-table',
  templateUrl: './bom-table.component.html',
  styleUrls: ['./bom-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BomTableComponent implements OnInit, OnChanges {

  negateEllipseLoading: boolean = false;
  quickAddLoading: boolean= false;

  canViewPricing = false;
  canViewAvailability = false;
  canEditMasterBom = false;
  isTesscoAdmin: boolean = false;

  toggleBomRow = {};
  bomSearchValue = '';

  loading = false;
  page = 1;
  pageSize = 50;

  quoteDetailsHash: any = {};

  invalidSkus: string[] = [];
  bomLineInputSku: string[] = [];
  bomLineArray: Array<BomLineInput> = [];
  newDynamic: any = {};
  quickAddFlag: boolean = false;

  bomItems: BomTableRow[] = [];
  bomItemsFiltered: BomTableRow[] = [];
  bomItemsFilteredBackup: BomTableRow[] = [];
  bomItemsSelectedIds: string[] = [];
  bomItemsDeletedIds: string[] = [];
  bomItemsToShow: BomTableRow[] = [];
  placeholderBomLineItems: BomLine[] = [];
  bomLinesWithErrors: BomLine[] = [];
  bomLinesWithoutErrors: BomLine[] = [];

  isBomItemsMoved:boolean = false;
  bomLineAndItsIndex: { bomLineId: string, index: number}[] = [];

  skus: string[] = [];
  incompatibleSkus: string[] = [];
  incompatibleSkusToBeDeleted: string[] = [];

  showAddItem = true;
  addingItem = false;
  newItem: Product;
  newItemQty: number;
  newItemAboveLineComment: string;
  newItemBelowLineComment: string;

  newLineCommentFlag: boolean = false;
  newBlcFlag: boolean = false;
  poLineEditing: boolean = true;
  qtyEditingFlag: boolean = true;
  bomLineID: string;

  totalPrice = 0;

  userRoles: string[] = [];
  skusAdjusted: any[] = [];

  placeholderItem = false;
  placeholderForm: FormGroup;
  placeHolderItems: FormArray;
  placeholderSelectedIds: string[] = [];

  $quoteUpdateComplete = new Subject<boolean>();
  warningMessages$: Subject<string[]> = new Subject();
  errorMessages$: Subject<string[]> = new Subject();

  warningMessagesList: string[] = [];
  errorMessagesList: string[] = [];

  isWaiting$: Subject<boolean> = new Subject();
  roleRequest: RoleRequest;

  purchasePlans: PurchasePlan[];
  purchasePlanCode: string;
  defaultPurchasePlanSelect: boolean = true;
  forceQuoteForPurchasePlan: boolean = false;

  $qtySubject: Subject<any> = new Subject();
  $poLineSubject: Subject<any> = new Subject();
  $aboveLineCommentSubject: Subject<any> = new Subject();
  $belowLineCommentSubject: Subject<any> = new Subject();

  // new variables added below
  orderSimulationData: OrderSimulation;
  orderLines: OrderLines[];
  shippingAndHandling: ShippingAndHandling;
  skuList: string[] = [];
  stockValueHash;
  bomLines: BomLine[] = [];
  productSelected: boolean = false;
  bomLineAndItsPOLineNumbers: BomLineInput[] = [];

  showFilterTypes: boolean = false;
  currentStatusFilter: string = 'PAGINATED';
  bomFilterTypes = [
    { status: 'Show All Records', value: 'ALL' },
    { status: 'Show Records By Pagination', value: 'PAGINATED' }
  ];
  @Output() poLineNumberDetails: EventEmitter<BomLineInput[]> = new EventEmitter<BomLineInput[]>();

  footerContext = {
    deleteItems: this.deleteItems.bind(this), 
    moveBomRowsUp: this.moveBomRowsUp.bind(this), moveBomRowsDown: this.moveBomRowsDown.bind(this),
    reorderBomLines: this.reorderBomLines.bind(this)
  };

  @ContentChild(TemplateRef) footerTemplate: TemplateRef<any>;

  @Output() rowsChange: EventEmitter<BomLine[]> = new EventEmitter<BomLine[]>();
  @Output() quoteUpdateComplete: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() worksheetUpdate: EventEmitter<Worksheet> = new EventEmitter<Worksheet>();
  @Output() worksheetContinueFlag: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() bomId: string;
  @Input() worksheetId: string;
  @Input() edit: boolean;
  @Input() set isEdit(value) {
    this.edit = value;
    if(this.edit){
      this.clearAllMessages();
    }
  }
  @Input() type: string;
  @Input() accountNumber: string;
  @Input() accountNumbers: String[]=[];
  @Input() orgId: string;
  @Input() selectedPurchasePlan: PurchasePlan;
  @Input() orderPageFlag: boolean = false;
  @Input() itemSearchText: string;
  @Input() isBulkPOLineNumberUpdationReqd: boolean;
  @Input() worksheetMessages : string;
  @Input() purchasePlanFlag: boolean = false;
  selectAll: boolean = false;
  orderDetail: OrderDetail;
  newItemSectionHeader: string;
  $sectionHeaderSubject: Subject<any> = new Subject();

  @Input()
  set bomLinesInput(obs: Observable<BomLine[]>) {
    !obs ? '': obs.subscribe((bomLines) => {
      this.setData(bomLines);
    });
  }

  setData(bomLines){
    if (bomLines.length) {
      this.bomLines = bomLines;
      this.loading = true;
      if (this.type === 'worksheet' && !this.edit) {
        this.setNegateEllipseLoading(false);
        this.isWaiting$.next(true);
        this.bomTableService.addWaitingQuoteItems(bomLines.map(line => line.id));
        // Fetching pricing information
        this.setPricingAndAvailibility(this.worksheetId);
        this.forceQuoteForPurchasePlan = false;
      }
      this.bomTableService.toTableBomRowsV2(this.bomLines, this.accountNumber, this.orgId)
        .subscribe(rows => {
          this.bomItems = rows;
          this.bomItemsToShow = this.bomItems;
          this.bomItemsFiltered = this.bomItems.slice();
          this.bomLineAndItsIndex = [];
          this.bomItems.forEach(item => {
            this.bomLineAndItsIndex.push({ bomLineId: item.line.id, index: item.line.index })
          });
          this.loadPage(1);
          this.bomItemsFilteredBackup = this.bomItems.filter(item => !item.line.isPlaceHolderItem).slice();
          this.loading = false;
          this.setNegateEllipseLoading(true);
        });
    } else {
      this.bomItems = [];
      this.bomItemsToShow = this.bomItems;
    }
  }

  setPricingAndAvailibility(worksheetId: string) {
    this.projectService.getOrderSimulation(worksheetId).subscribe(response => {
      this.orderDetail = response;
      if(this.orderDetail.statusMessages != null){
        this.orderDetail.statusMessages.forEach(msg => {
          if (msg.message) {
            this.pushWarningMessagesIntoArray(msg.message);
          }
        });
      }
      this.loadWarningMessages();
      this.bomTableService.setPricingAndAvailabilityDetails(this.orderDetail.orderLines);
      this.$quoteUpdateComplete.next(response.orderLines.length > 0);
    },error => {
      const message = error.error.message ? error.error.message.split("\n") : ['Error while fetching the Pricing & Availability!!'];
      this.pushErrorMessagesIntoArray(message);
      this.loadErrorMessages();
      this.$quoteUpdateComplete.next(false);
    });
  }

  getBomRows(orderLines: OrderLines[]){
    const skus = orderLines.map(orderLine => orderLine.sku);
    if (skus.length) {
      return this.productAliasService.productDetailsV2(skus, this.accountNumber)
        .map(product => {
          return orderLines.map((orderLine) => {
            const data = product.find(prod => prod.sku === orderLine.sku);
            return { line: orderLine, data };
          });
        });
    } else {
      return of([]);
    }
  }

  openImportExportDialog() {
    const modalRef = this.modalService.open(BomCsvUploadErrorComponent, {
      backdrop : 'static',
      size: 'lg',
      keyboard : false
    });
    modalRef.componentInstance.bomLines = this.bomLinesWithErrors;

    modalRef.result.then(() => { }).catch(() => { });
  }

  private mapAllPlaceholderItems(placeholderBomLineItems: BomLine[]): FormGroup[] {
    const phBomLineList: FormGroup[] = [];

    placeholderBomLineItems.forEach(item => {
      const itemForm = this.mapPlaceholderItem(item);
      phBomLineList.push(itemForm);
    });

    return phBomLineList;
  }

  private mapPlaceholderItem(placeholder: BomLine): FormGroup {
    const newItemForm = this.formBuilder.group({
      id: placeholder.id,
      partNumber: placeholder.partNumber,
      placeHolderManuf: placeholder.placeHolderManuf,
      placeHolderManufPartNumber: placeholder.placeHolderManufPartNumber,
      placeHolderDescr: placeholder.placeHolderDescr,
      quantity: placeholder.quantity,
      placeHolderPrice: placeholder.placeHolderPrice
    });

    newItemForm.valueChanges.debounceTime(500).subscribe(form => {
      const updatedPlaceHolderBomLine = placeholder;
      Object.assign(updatedPlaceHolderBomLine, form);
      updatedPlaceHolderBomLine.accountNumber = this.accountNumber;
      this.projectService.updateBomLine(this.bomId, updatedPlaceHolderBomLine)
        .subscribe(() => {
          this.onUpdateSuccess();
        }, () => {
          this.onUpdateError('There was an error saving the item');
        });
    });

    return newItemForm;
  }

  private onUpdateSuccess() {
    this.toastr.success('Item saved!!!', 'Succcess!', {
      timeOut: 2000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateError(error: string) {
    this.toastr.error(error, 'Error!', {
      timeOut: 2000,
      positionClass: 'toast-bottom-right'
    });
  }

  private showWarningMsg(msg: string){
    this.toastr.warning(msg, 'Warning!', {
      timeOut: 2000,
      positionClass: 'toast-bottom-right'
    });
  }

  constructor(
    private bomTableService: BomTableService,
    private authService: AuthService,
    private projectService: ProjectService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private elRef: ElementRef,
    private productAliasService: ProductAliasService,
    ) {
      this.projectService.addRowsToWorksheetClicked.subscribe(value => {
        if(value){ this.dismissWarningMessages(); }
      });
      this.bomTableService.worksheetSaveClicked.subscribe(value => {
        if(value){ this.clearOrMergeWarningMessages(); }
      });
     }

  loadPage(page) {
    this.unselectAllItems();
    this.page = page;
    const from = (page - 1) * this.pageSize;
    const to = from + this.pageSize;
    if (this.isBomItemsMoved) {
      this.resetBOMLineIndexes();
    }
    this.bomItemsToShow = this.bomItemsFiltered.slice(from, to);
    if(this.bomItemsToShow.length){
      this.loading = false;
    }
  }

   /** 
    * whenever bom items are moved, its index values are changed.Hence resetting the indexes.
    * Refer OASIS-3072
   */
  private resetBOMLineIndexes() {
    this.bomItemsFiltered.forEach(item => {
      const bomLine = this.bomLineAndItsIndex.find(line => line.bomLineId == item.line.id);
      item.line.index = bomLine.index;
    });
  }

  getOrderSimulationResponse() {
    return this.orderDetail;
  }

  getDataFromOrderLines(bomLineId: string, fieldName: string){
    let orderLine = this.getOrderSimulationResponse()
                      .orderLines.find(ol => ol.bomLineId === bomLineId);
    if(orderLine) {
      switch(fieldName){
        case 'Unit Price': return orderLine.price;
        case 'Price': return orderLine.price * orderLine.quantity;
      }
    }
  }

  getStockDetailFromOrderLines(){
    this.stockValueHash = {};
    this.orderLines.forEach((orderLine) => {
      let text, klass, availability;
      if (orderLine.quantity <= orderLine.quantityAvailable) {
        text = 'IN';
        klass = 'in-color';
      } else if (orderLine.quantityAvailable > 0) {
        text = 'PARTIAL';
        klass = 'partial-color';
      } else {
        text = 'OUT';
        klass = 'out-color';
      }
      availability = {
        qty: orderLine.quantity, qtyAvailable: orderLine.quantityAvailable,
        backorderAvailabilities: orderLine.backorderAvailabilities.length ? orderLine.backorderAvailabilities : null
      };
      this.stockValueHash[orderLine.bomLineId] = { label: text, class: klass, availability: availability };
    });
  }

  setItemToAdd(item: Product) {
    this.newItem = item;
  }

  // Quick Add
  addRow(index) {
    this.newDynamic = {bomId: this.bomId,partNumber: "", quantity: ""};
    this.bomLineArray.push(this.newDynamic);
    return true;
}

deleteRow(index) {
    if(this.bomLineArray.length ==1) {
      this.toastr.error("Can't delete the row when there is only one row", 'Warning');
        return false;
    } else {
        this.bomLineArray.splice(index, 1);
        return true;
    }
}

cancelItems(){
  this.bomLineArray = [];
  this.newDynamic = {bomId: this.bomId, partNumber: "", quantity: ""};
  this.bomLineArray.push(this.newDynamic);
}

  quickAddItems() {
    if (this.bomLineArray.some(item => { return item.quantity == 0;})) {
      this.onUpdateError('Quantity can not be empty or zero in Quick add SKUs');
    }else{
      this.quickAddLoading = true;
      this.bomLineArray.forEach(eachBom => {
        this.bomLineInputSku.push(eachBom.partNumber);
      });
      this.bomTableService.quickAddItems(this.bomLineArray)
        .subscribe((bomLines: BomLine[]) => {
          if (this.type === 'worksheet') {
            this.bomTableService.addWaitingQuoteItems(bomLines.map(line => line.id));
          }

          if (bomLines[0].message) {
            //check for skus whose quantity is adjusted and which are not valid
              let messages: string[] = bomLines[0].message.split(";");
              messages.forEach(msg => {
                if (msg.indexOf('not valid') > 0) {
                  this.pushErrorMessagesIntoArray(msg);
                } else {
                  this.pushWarningMessagesIntoArray(msg);
                }
              });
              this.loadWarningMessages();
              this.loadErrorMessages();
          }
          this.bomTableService.toTableBomRowsV2(bomLines, this.accountNumber, this.orgId)
            .subscribe(rows => {
              if(rows.length > 0) {
                if (this.type == 'bom') {
                  rows.forEach(row => {
                    this.bomItems.push(row);
                    this.bomItemsFiltered.push(row);
                  });
                } else {
                  rows.forEach(row => {
                    this.bomItems = this.bomTableService.addToRowsInPlaceOrBeginning(this.bomItems, row);
                    this.bomItemsFiltered = this.bomTableService.addToRowsInPlaceOrBeginning(this.bomItemsFiltered, row);
                  });
                }
                this.bomItemsToShow = this.bomItems;
                this.emitRowsChange();
                this.addingItem = false;
                this.quickAddLoading = false;
              }
            });
        }, error => {
          this.pushErrorMessagesIntoArray(error.error.message);
          this.loadErrorMessages();
          this.quickAddLoading = false;
        });
      // clear the fields once request is submitted.
      this.cancelItems();
    }
  }
  // Quick Add ends

  unselectAllItems() {
    if (this.bomItemsSelectedIds && this.bomItemsSelectedIds.length) {
      this.bomItemsToShow.forEach(bits => {
        bits.line.isSelected = false;
      });
      this.bomItemsSelectedIds = [];
      let elements = this.elRef.nativeElement.querySelectorAll('.table-active');
      if (elements) {
        elements.forEach(el => {
          el.className="";
        });
      }
    }
  }

  addItemV2(item: Product, qty: number = 0, aboveLineComment: string = null, belowLineComment: string = null, sectionHeader: string = null) {

    this.addingItem = true;
    this.productSelected = false;
    this.newLineCommentFlag = false;
    this.newItemAboveLineComment = null;
    this.newItemBelowLineComment = null;
    this.newItemSectionHeader = null;
    this.selectAll = false;
    const bomLineRequest = new BomLinesRequest();
    bomLineRequest.bomId = this.bomId;
    bomLineRequest.worksheetId = this.worksheetId;
    if (this.accountNumber === undefined) {
      this.accountNumber = '';
    }
    if (this.orgId === undefined) {
      this.orgId = '';
    }
    bomLineRequest.customerNumber = this.accountNumber;
    bomLineRequest.orgId = this.orgId;
    bomLineRequest.sectionHeader = sectionHeader;
    const bomLine = new BomLine();
    bomLine.partNumber = item.sku;
    if (qty < item.minimumQuantity && this.type != 'bom') {
      this.skusAdjusted.push({sku: item.sku, qty: item.minimumQuantity});
      this.pushWarningMessagesIntoArray(this.getMinQtyAdjustedSKUMessage(item.minimumQuantity, item.sku));
      this.loadWarningMessages();
      qty = item.minimumQuantity;
    }
    bomLine.quantity = qty;
    bomLine.isCableItem = item.isCableItem;
    bomLine.isConsignmentItem = item.isConsignedItem;
    bomLine.aboveLineComment = aboveLineComment;
    bomLine.belowLineComment = belowLineComment;

    bomLineRequest.bomLines = [bomLine];

    this.bomTableService.addItemsV2(bomLineRequest).subscribe(newLine => {
      if (this.type === 'worksheet') {
        newLine.forEach(line => this.bomTableService.addWaitingQuoteItems([line.id]))
      }
      this.skus.push(item.sku);
      this.bomTableService.toTableBomRowsV2(newLine, this.accountNumber, this.orgId)
        .subscribe(rows => {
          if (this.type == 'bom') {
            rows.forEach(row => {
              this.bomItems.push(row);
              this.bomItemsFiltered.push(row);
            });
          } else {
            rows.forEach(row => {
              this.bomItems = this.bomTableService.addToRowsInPlaceOrBeginning(this.bomItems, row);
              this.bomItemsFiltered = this.bomTableService.addToRowsInPlaceOrBeginning(this.bomItemsFiltered, row);
            });
          }
          this.bomItemsToShow = this.bomItems;
          this.emitRowsChange();
          this.showAddItem = true;
          this.addingItem = false;
          if (this.type === 'worksheet') {
            this.newItemQty = null;
          }
           this.newItem =null;
           this.productSelected = true;
           this.newItemAboveLineComment = null;
           this.newItemBelowLineComment = null;
           this.loadAllWarningMessages();
        });
    },
    error => {
      this.pushWarningMessagesIntoArray(error.error.message);
      this.loadWarningMessages();
      this.showAddItem = true;
      this.addingItem = false;
      this.newItem =null;
      this.productSelected = true;
      this.newItemAboveLineComment = null;
      this.newItemBelowLineComment = null;
    }
    );
  }

  deleteItems() {
    if(!this.bomItemsSelectedIds || this.bomItemsSelectedIds.length <= 0){
      this.showWarningMsg('Please select row(s) to delete');
    } else {
      let message;
      if (this.bomItemsToShow.length == this.bomItemsSelectedIds.length) {
        this.deleteAllItems();
      } else {
        this.bomTableService.deleteBomLines(this.bomId, this.bomItemsSelectedIds)
        .subscribe(lines => {
          lines.forEach(line => {
            this.bomItems.find(i => i.line.id === line.id).line.quantity = line.quantity;
            message = line.message ? line.message : message;
            if(line.isDeleted) {
              this.bomItemsDeletedIds.push(line.id);
              const poLineIndex = this.bomLineAndItsPOLineNumbers.findIndex(bomLine => bomLine.bomLineId === line.id);
              this.bomLineAndItsPOLineNumbers.splice(poLineIndex, 1);
              this.incompatibleSkusToBeDeleted = this.incompatibleSkusToBeDeleted.filter(sku => sku !== (line.partNumber));
              this.skus = this.skus.filter(sku => sku !== (line.partNumber));
            } else {
              this.bomItems.find(i => i.line.id === line.id).line.isSelected = false;
            }
          });
          this.bomItems = this.bomItems.filter(z => !this.bomItemsDeletedIds.includes(z.line.id));
          this.bomItemsFiltered = this.bomItems.slice();
          this.bomTableService.addWaitingQuoteItems(this.bomItemsFiltered.map(bi => bi.line.id));
          this.bomItemsToShow = this.bomItems;
          this.bomItemsSelectedIds = [];
          this.bomItemsDeletedIds = [];
  
          this.emitRowsChange();
          this.projectService.getBomLines(this.bomId).subscribe(items => {
            this.setData(items);
          });
          this.onUpdateBomLineSuccess(message);
          if(this.incompatibleSkusToBeDeleted.length < 1) {
            this.worksheetContinueFlag.emit(true);
          }
        });
       }
      // this.placeholderSelectedIds.forEach(phId => {
      //   this.projectService.deleteBomLine(phId).subscribe(() => {
      //     this.placeHolderItems.removeAt(this.placeHolderItems.value.findIndex(bl => bl.id === phId));
      //   });
      // });
    }
  }

  deleteAllItems() {
    const modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete all the items in this ` + this.type +` ?`;
    modalRef.componentInstance.fn = () => { 
      let message;
      this.bomItemsSelectedIds =  this.bomItemsToShow.map(bom=>bom.line.id);
      this.bomTableService.deleteBomLines(this.bomId, this.bomItemsSelectedIds)
       .subscribe(lines => {
         lines.forEach(line => {
           this.bomItems.find(i => i.line.id === line.id).line.quantity = line.quantity;
           message = line.message ? line.message : message;
           if(line.isDeleted) {
             this.bomItemsDeletedIds.push(line.id);
             const poLineIndex = this.bomLineAndItsPOLineNumbers.findIndex(bomLine => bomLine.bomLineId === line.id);
             this.bomLineAndItsPOLineNumbers.splice(poLineIndex, 1);
             this.incompatibleSkusToBeDeleted = this.incompatibleSkusToBeDeleted.filter(sku => sku !== ((line.isConsignmentItem && line.consignmentAliasSku) ? line.consignmentAliasSku : line.partNumber));
             this.skus = this.skus.filter(sku => sku !== ((line.isConsignmentItem && line.consignmentAliasSku) ? line.consignmentAliasSku : line.partNumber));
           } else {
             this.bomItems.find(i => i.line.id === line.id).line.isSelected = false;
           }
         });
         this.bomItems = this.bomItems.filter(z => !this.bomItemsDeletedIds.includes(z.line.id));
         this.bomItemsFiltered = this.bomItems.slice();
         this.bomTableService.addWaitingQuoteItems(this.bomItemsFiltered.map(bi => bi.line.id));
         this.bomItemsToShow = this.bomItems;
         this.bomItemsSelectedIds = [];
         this.bomItemsDeletedIds = [];
         this.emitRowsChange();
         this.projectService.getBomLines(this.bomId).subscribe(items => {
           this.setData(items);
         });
         this.onUpdateBomLineSuccess(message);
         if(this.incompatibleSkusToBeDeleted.length < 1) {
           this.worksheetContinueFlag.emit(true);
         }
         modalRef.close();
       });
    };
  }


  selectItem(item: BomTableRow, event) {
    const itemAlreadySelected = this.bomItemsSelectedIds.some(x => x === item.line.id);
    if (itemAlreadySelected) {
      this.selectAll = false;
      this.bomItemsSelectedIds = this.bomItemsSelectedIds.filter(x => x !== item.line.id);
      if (this.type == 'bom') {
        event.target.parentNode.parentNode.parentNode.className = undefined;
      }
    } else {
      this.bomItemsSelectedIds.push(item.line.id);
      if (this.type == 'bom') {
        event.target.parentNode.parentNode.parentNode.className = "table-active";
      }
    }
    if (this.bomItemsSelectedIds.length == this.bomItemsToShow.length) {
      this.selectAll = true;
    } else {
      this.selectAll = false;
    }
  }

  selectAllItem(event) {
    this.selectAll = event.target.checked;
    this.bomItemsSelectedIds = [];
    if (this.selectAll) {
      this.bomItems.forEach(item => {
        item.line.isSelected = true;
        this.bomItemsSelectedIds.push(item.line.id);
      });
    } else {
      this.bomItemsSelectedIds = [];
      this.bomItems.forEach(item => {
        item.line.isSelected = false;
      });
    }
  }

  selectPlaceholder(placeholder: FormGroup) {
    const placeholderAlreadySelected = this.placeholderSelectedIds.some(x => x === placeholder.get('id').value);
    if (placeholderAlreadySelected) {
      this.placeholderSelectedIds = this.placeholderSelectedIds.filter(x => x !== placeholder.get('id').value);
    } else {
      this.placeholderSelectedIds.push(placeholder.get('id').value);
    }
  }

  isPlaceholderSelected(placeholder: FormGroup) {
    return this.placeholderSelectedIds.some(x => x === placeholder.get('id').value);
  }

  changeItem(item: BomTableRow, input: HTMLInputElement) {
    let qty = Number(input.value);
    if (qty >= 0) {
      const model = this.bomItems.find(i => i.line.id === item.line.id);
      model.line.quantity = item.line.quantity = qty;
      model.line.details = item.data;
      this.emitRowsChange();
    } else {
      input.value = '0';
    }
  }

  updateItem(item: BomTableRow, qty: number) {
    const model = this.bomItems.find(i => i.line.id === item.line.id);
    model.line.quantity = item.line.quantity = qty;
    model.line.accountNumber = this.accountNumber;
    this.projectService.updateBomLine(this.bomId, model.line).subscribe(() => {
      this.bomTableService.addWaitingQuoteItems([model.line.id]);
    });
  }

  cutCable(bomLineItem: BomTableRow) {
    const modalRef = this.modalService.open(CutCableModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.bomId = this.bomId;
    modalRef.componentInstance.bomLineId = bomLineItem.line.id;

    modalRef.result
      .then(newQuantity => {
        bomLineItem.line.quantity = newQuantity;
        this.bomTableService.addWaitingQuoteItems([bomLineItem.line.id]);
      })
      .catch(console.error);
  }

  isSelected(item) {
    return this.bomItemsSelectedIds.some(x => x === item.id);
  }

  private emitRowsChange() {
    this.rowsChange.emit(this.bomItems.map(i => i.line));
  }

  isWaitingItem(lineId: string) {
    return this.bomTableService.isWaitingQuote(lineId);
  }

  getHazmatSkus() {
    if (this.bomTableService.hazmatSkus.length > 0) {
      const hazmatSkus = new Set(this.bomTableService.hazmatSkus);
      let errorMsgStr = "The cart contains a Hazmat item (SKU # " + Array.from(hazmatSkus).join(", ") + ")."
      this.pushWarningMessagesIntoArray(errorMsgStr);
      this.loadWarningMessages();
      this.bomTableService.dismissHazmat();
    } 
  }

  updateAboveLineComment() {
    this.$aboveLineCommentSubject
    .debounceTime(1000)
    .distinctUntilChanged()
    .subscribe((data: [BomTableRow, HTMLInputElement]) => {
      const row = data[0];
      const input = data[1];
      let alc = String(input.value);
      const model = this.bomItems.find(i => i.line.id === row.line.id);
      if (this.type === 'worksheet') {
        this.bomItems.find(i => i.line.id === row.line.id).line.aboveLineComment = alc;
        model.line.aboveLineComment = row.line.aboveLineComment = alc;
        let message;
        model.line.accountNumber = this.accountNumber;
        this.projectService.updateBomLine(this.bomId, model.line).subscribe(lines => {
          this.bomTableService.addWaitingQuoteItems([model.line.id]);
          lines.forEach(
            line => {
              if(line.isNew) {
                this.bomTableService.toTableBomRowsV2(lines, this.accountNumber, this.orgId)
                  .subscribe(rows => {
                    this.bomItems.push(rows[0]);
                    this.bomItemsToShow.push(rows[0]);
                    message = line.message ? line.message : message;
                  });
              } else {
                this.bomItems.find(i => i.line.id === line.id).line.quantity = line.quantity;
                message = line.message ? line.message : message;
              }
            }
          );
          this.onUpdateBomLineSuccess(message);
        }, error => {
          this.onUpdateBomLineError(error.error.message);
        });
      } else if (this.type === 'bom') {
        if (model) {
          model.line.aboveLineComment = row.line.aboveLineComment = alc;
          model.line.accountNumber = this.accountNumber;
          if (this.edit === true) {
            this.projectService.updateBomLine(this.bomId, model.line).subscribe(lines => {
              this.emitRowsChange();
            });
          } else {
            this.emitRowsChange();
          }
        }
      }
    });
  }

  updateBelowLineComment() {
    this.$belowLineCommentSubject
    .debounceTime(1000)
    .distinctUntilChanged()
    .subscribe((data: [BomTableRow, HTMLInputElement]) => {
      const row = data[0];
      const input = data[1];
      let blc = String(input.value);
      const model = this.bomItems.find(i => i.line.id === row.line.id);
      if (this.type === 'worksheet') {
        this.bomItems.find(i => i.line.id === row.line.id).line.belowLineComment = blc;
        model.line.belowLineComment = row.line.belowLineComment = blc;
        let message;
        model.line.accountNumber = this.accountNumber;
        this.projectService.updateBomLine(this.bomId, model.line).subscribe(lines => {
          this.bomTableService.addWaitingQuoteItems([model.line.id]);
          lines.forEach(
            line => {
              if(line.isNew) {
                this.bomTableService.toTableBomRowsV2(lines, this.accountNumber, this.orgId)
                  .subscribe(rows => {
                    this.bomItems.push(rows[0]);
                    this.bomItemsToShow.push(rows[0]);
                    message = line.message ? line.message : message;
                  });
              } else {
                this.bomItems.find(i => i.line.id === line.id).line.quantity = line.quantity;
                message = line.message ? line.message : message;
              }
            }
          );
          this.onUpdateBomLineSuccess(message);
        }, error => {
          this.onUpdateBomLineError(error.error.message);
        });
      } else if (this.type === 'bom') {
        if (model) {
          model.line.belowLineComment = row.line.belowLineComment = blc;
          model.line.accountNumber = this.accountNumber;
          if (this.edit === true) {
            this.projectService.updateBomLine(this.bomId, model.line).subscribe(lines => {
              this.emitRowsChange();
            });
          } else {
            this.emitRowsChange();
          }
        }
      }
    });
  }

  updateQty() {
    this.$qtySubject
      .debounceTime(1000)
      .distinctUntilChanged()
      .subscribe((data: [BomTableRow, HTMLInputElement]) => {
        const row = data[0];
        const input = data[1];
        let qty = Number(input.value);
        if (qty > 0) {
          const model = this.bomItems.find(i => i.line.id === row.line.id);
          if (qty < row.data.minimumQuantity) {
            qty = row.data.minimumQuantity;
            input.value = row.data.minimumQuantity.toString();
            this.skusAdjusted.push({sku: row.data.sku, qty: row.data.minimumQuantity});
            this.pushWarningMessagesIntoArray(this.getMinQtyAdjustedSKUMessage(row.data.minimumQuantity,row.data.sku));
            this.loadWarningMessages();
            if (row.data.isCableItem) {
              model.line.isCableSkuQtyAdjusted = true;
            }
          }
          this.bomItems.find(i => i.line.id === row.line.id).line.quantity = qty;
          model.line.quantity = row.line.quantity = qty;
          let message;
          model.line.accountNumber = this.accountNumber;
          this.projectService.updateBomLine(this.bomId, model.line).subscribe(lines => {
            this.bomTableService.addWaitingQuoteItems([model.line.id]);
            lines.forEach(
              line => {
                if(line.isNew) {
                  this.bomTableService.toTableBomRowsV2(lines, this.accountNumber, this.orgId)
                    .subscribe(rows => {
                      this.bomItems.push(rows[0]);
                      this.bomItemsToShow.push(rows[0]);
                      message = line.message ? line.message : message;
                      this.qtyEditingFlag = true;
                    });
                } else {
                  this.bomItems.find(i => i.line.id === line.id).line.quantity = line.quantity;
                  message = line.message ? line.message : message;
                  this.qtyEditingFlag = true;
                }
              }
            );
            this.onUpdateBomLineSuccess(message);
            this.qtyEditingFlag = true;
          }, error => {
            this.onUpdateBomLineError(error.error.message);
            this.qtyEditingFlag = true;
          });
        } else {
          this.qtyEditingFlag = true;
        }
      });
  }

  ngOnInit() {
    this.newDynamic = {bomId: this.bomId, partNumber: "", quantity: ""};
    this.bomLineArray.push(this.newDynamic);

    this.roleRequest = new RoleRequest('AVAILABILITY_VIEW', null);
    this.roleRequest.setRoleAndContextMap('PRICING_VIEW', null);
    this.roleRequest.setRoleAndContextMap('MASTER_BOM_UPDATE', null);
    this.roleRequest.setRoleAndContextMap('ADMIN_TESSCO', null);
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
      this.canViewAvailability = roles.getRoleMap('AVAILABILITY_VIEW');
      this.canViewPricing = roles.getRoleMap('PRICING_VIEW');
      this.canEditMasterBom = roles.getRoleMap('MASTER_BOM_UPDATE');
      this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
    });

    if (this.type === 'worksheet') {
      this.pageSize = 200;

      this.setSkuQtyAdjustedWarningMessages();

      this.fetchPurchasePlans(this.accountNumber);

      this.authService.getUserRolesInContext(`WORKSHEET~${this.worksheetId}`).subscribe(roles => {
        this.userRoles = roles;
      });

      this.bomTableService.$quoteDetailsSubject.subscribe(newValue => {
        this.setNegateEllipseLoading(false);
        this.bomTableService.cleanWaitingItems();
        this.quoteDetailsHash = newValue;
        this.setNegateEllipseLoading(true);
      });

      this.updateQty();
      this.bomTableService.$cleanMessagesSubject.subscribe(() => {
        this.clearAllMessages();
      });

      this.setNegateEllipseLoading(false);
      this.forceQuoteForPurchasePlan = false;

      this.$quoteUpdateComplete.subscribe(message => {
        this.quoteUpdateComplete.emit(Boolean(message));
        this.setNegateEllipseLoading(true);
        this.isWaiting$.next(undefined);
        this.totalPrice = this.bomTableService.getTotalPrice(this.getOrderSimulationResponse());

        // TDOD redundent call
        this.bomTableService.getBomLines(this.bomId).subscribe(result => {
          this.bomTableService.toTableBomRowsV2(result, this.accountNumber, this.orgId)
          .subscribe(rows => {
            this.bomItems = rows;
            this.bomItemsToShow = this.bomItems;
            this.populatePOLineNumbesForAllBOMLines();
            this.loading = false;
            this.setNegateEllipseLoading(true);
            this.getHazmatSkus();
          });
        });
        if (this.selectedPurchasePlan != null && this.selectedPurchasePlan.purchasePlanId !== undefined) {
          this.purchasePlanCode = this.selectedPurchasePlan.purchasePlanId;
          this.findIncompatibleSkus(this.selectedPurchasePlan.groupingCategory);
        }
      });
    }  

    this.updateAboveLineComment();
    this.updateBelowLineComment();

    this.updatePoLineNumber();
    this.updateSectionHeader();

    if (this.bomId!==undefined && !this.bomId && this.edit) {
      throw new Error('Bom Id needed for current bom-table type');
    }
  }

  private setSkuQtyAdjustedWarningMessages() {
    if (this.worksheetMessages) {
      let messages: string[] = this.worksheetMessages.split(';');
      messages.forEach(msg => {
        if (msg.indexOf('not valid') > 0) {
          this.pushErrorMessagesIntoArray(msg);
        } else {
          this.pushWarningMessagesIntoArray(msg);
        }
      });
      this.loadWarningMessages();
      this.loadErrorMessages();
    }
  }

  clearAllMessages(){
    this.dismissWarningMessages();
    this.dismissErrorMessages();
  }

  clearOrMergeWarningMessages(){
    if(this.warningMessagesList.length > 0){
      let newList = this.warningMessagesList.filter(msg => msg.includes("Hazmat item"));
      for(let msg of newList){
        const index = this.warningMessagesList.indexOf(msg);
        if(index > -1) {
          this.warningMessagesList.splice(index, 1);
        }
      }
      this.warningMessages$.next(undefined);
      this.warningMessages$.next(this.warningMessagesList);
    }
  }

  fetchPurchasePlans(accountNumber: string) {
    if (accountNumber && this.edit && this.purchasePlanFlag) {
      this.productAliasService.getPurchasePlans(this.accountNumber).subscribe(purchasePlans => {
        this.purchasePlans = purchasePlans;
        this.purchasePlans.forEach(purchasePlan => {
          if (purchasePlan.purchasePlanId === this.purchasePlanCode) {
            this.defaultPurchasePlanSelect = false;
          }
        });
      });
    }

    if (this.selectedPurchasePlan != null && this.selectedPurchasePlan.purchasePlanId != null) {
      this.purchasePlanCode = this.selectedPurchasePlan.purchasePlanId;
      if(!this.edit){
        this.findIncompatibleSkus(this.selectedPurchasePlan.groupingCategory);
      }
    }
  }

  selectPurchasePlan(selectedPurchasePlan: string) {
    this.setNegateEllipseLoading(false);
    this.forceQuoteForPurchasePlan = true;
    if(selectedPurchasePlan !== '1') {
      this.projectService.savePurchasePlan(this.worksheetId, selectedPurchasePlan).subscribe(worksheet => {
        this.purchasePlanCode = selectedPurchasePlan;
        this.worksheetUpdate.emit(worksheet);
      });
    } else {
      this.selectedPurchasePlan = null;
      this.projectService.savePurchasePlan(this.worksheetId, null).subscribe(worksheet => {
        this.incompatibleSkus = [];
        this.incompatibleSkusToBeDeleted = [];
        this.purchasePlanCode = null;
        this.defaultPurchasePlanSelect = true;
        this.worksheetUpdate.emit(worksheet);
        this.worksheetContinueFlag.emit(true);
      });
    }
  }

  getInvalidSkus() {
    return this.invalidSkus;
  }

  dismissInvalidSkus(){
    this.invalidSkus = [];
    this.bomLineInputSku = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    let messages: SimpleChange = changes.worksheetMessages;
    if (messages) {
      this.worksheetMessages = messages.currentValue;
      this.setSkuQtyAdjustedWarningMessages();
    }

    let accountNumber: SimpleChange = changes.accountNumber;
    if(accountNumber) {
      this.accountNumber = accountNumber.currentValue;
    }

    let accountNumbers: SimpleChange = changes.accountNumbers;
    if(accountNumbers) {
      this.accountNumbers = accountNumbers.currentValue;
    }  
    
    let purchasePlanFlag: SimpleChange = changes.purchasePlanFlag;
    if (purchasePlanFlag) {
      this.purchasePlanFlag = purchasePlanFlag.currentValue;
    }
    if (this.type === 'worksheet') {
      this.fetchPurchasePlans(this.accountNumber);
    }
    
    let purchasePlanObtained: SimpleChange = changes.selectedPurchasePlan;
    if (purchasePlanObtained !== undefined && purchasePlanObtained != null) {
      this.selectedPurchasePlan = purchasePlanObtained.currentValue;
    }
    if(this.edit){
      this.orderSimulationData = null;
    }
    let bomId: SimpleChange = changes.bomId;
    if (bomId) {
      this.bomId = bomId.currentValue;
    }

    let itemSearchText: SimpleChange = changes.itemSearchText;
    if (itemSearchText) {
      this.itemSearchText = itemSearchText.currentValue;
      if (this.itemSearchText && this.itemSearchText.length) {
          var searchText = this.itemSearchText.toUpperCase();
          var tempText = this.itemSearchText;
          let tempVar = this.highlightSearchText(tempText);

          // Tokenize the search text
          let tokens = searchText.split(' ');
          this.bomItemsFiltered = tempVar.filter(item => {
          let partNumber = item.line.partNumber.toUpperCase();
          let manufacturerName = item.data && item.data.manufacturerName ? item.data.manufacturerName.toUpperCase() : '';
          let manufacturerPartNumber = item.data && item.data.manufacturerPartNumber ? item.data.manufacturerPartNumber.toUpperCase() : '';
          let name = item.data && item.data.name ? item.data.name.toUpperCase() : '';

          return tokens.some(token =>
            partNumber.includes(token) ||
            manufacturerName.includes(token) ||
            manufacturerPartNumber.includes(token) ||
            name.includes(token)
          );
        });

        this.loadPage(1);
      } else {
        this.bomItemsFiltered = this.bomItemsFilteredBackup;
        this.loadPage(1);
      }
    }
  }

  highlightSearchText(searchText) {
    // Clone the object without changing the original data
    var tempVar = JSON.parse(JSON.stringify(this.bomItemsFilteredBackup));
    // Tokenize the search text
    let tokens = searchText.split(' ');

    tempVar.forEach(item => {
        let partNumber = item.line.partNumber ? item.line.partNumber : '';
        let manufacturerName = item.data && item.data.manufacturerName ? item.data.manufacturerName : '';
        let manufacturerPartNumber = item.data && item.data.manufacturerPartNumber ? item.data.manufacturerPartNumber : '';
        let name = item.data && item.data.name ? item.data.name : '';

        tokens.forEach(token => {
            let regex = new RegExp(`(${token})`, 'gi');
            if (partNumber) partNumber = partNumber.replace(regex, `<strong class="bg-warn">$1</strong>`);
            if (manufacturerName) manufacturerName = manufacturerName.replace(regex, `<strong class="bg-warn">$1</strong>`);
            if (manufacturerPartNumber) manufacturerPartNumber = manufacturerPartNumber.replace(regex, `<strong class="bg-warn">$1</strong>`);
            if (name) name = name.replace(regex, `<strong class="bg-warn">$1</strong>`);
        });

        if (partNumber) item.line.partNumber = partNumber;
        if (item.data && manufacturerName) item.data.manufacturerName = manufacturerName;
        if (item.data && manufacturerPartNumber) item.data.manufacturerPartNumber = manufacturerPartNumber;
        if (item.data && name) item.data.name = name;
    });
    return tempVar;
}

  getDefaultPurchasePlanSelect() {
    return this.defaultPurchasePlanSelect;
  }

  private onUpdateBomLineError(errorMessage: string) {
    this.toastr.error(errorMessage, 'Error!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateBomLineSuccess(message?: string) {
    this.toastr.success(message, 'Bom Line Updated!!!', {
      timeOut: 5500,
      positionClass: 'toast-bottom-right'
    });
  }

  public getNegateEllipseLoading(): boolean {
    return this.negateEllipseLoading;
  }

  public setNegateEllipseLoading(value: boolean) {
    this.negateEllipseLoading = value;
  }

  updatePoLineNumber() {
    //if bulk poline updation is reqd, no need to update individually
    if (this.isBulkPOLineNumberUpdationReqd !== undefined && !this.isBulkPOLineNumberUpdationReqd) {
      this.$poLineSubject
        .debounceTime(1000)
        .distinctUntilChanged()
        .subscribe((data: [BomTableRow, HTMLInputElement]) => {
          const row = data[0];
          const input = data[1];
          let poLineNumber = Number(input.value);
          if (isNaN(poLineNumber)) {
            this.onUpdatePoLineError("Po Line Number should be numeric value greater than 0");
            this.poLineEditing = true;
            return;
          }
          if (poLineNumber >= 1 || !poLineNumber) {
            if (poLineNumber > 999) {
              this.onUpdatePoLineError("Po Line Number should not be greater than 999.");
            } else {
              const model = this.bomItems.find(i => i.line.id === row.line.id);
              if (poLineNumber === model.line.poLineNumber) {
                this.onUpdatePoLineSuccess();
                this.poLineEditing = true;
              } else {
                let message;
                const prevPoLineNumber = model.line.poLineNumber;
                model.line.poLineNumber = poLineNumber;
                this.projectService.updatePoLineNumber(this.bomId, model.line).subscribe(lines => {
                  if (!this.orderPageFlag) {
                    this.bomTableService.addWaitingQuoteItems([model.line.id]);
                  }
                  lines.forEach(
                    line => {
                      if (line.isNew) {
                        this.bomTableService.toTableBomRowsV2(lines, this.accountNumber, this.orgId)
                          .subscribe(rows => {
                            this.bomItems.push(rows[0]);
                            this.bomItemsToShow.push(rows[0]);
                            message = line.message ? line.message : message;
                          });
                      } else {
                        this.bomItems.find(i => i.line.id === line.id).line.poLineNumber = line.poLineNumber;
                        row.line.poLineNumber = line.poLineNumber;
                        message = line.message ? line.message : message;
                      }
                    }
                  );
                  this.onUpdatePoLineSuccess(message);
                  this.poLineEditing = true;
                }, error => {
                  model.line.poLineNumber = prevPoLineNumber;
                  this.onUpdatePoLineError(error.error.message);
                  this.poLineEditing = true;
                });
              }
            }
          } else {
            this.onUpdatePoLineError("Po Line Number should be greater than 0.");
            this.poLineEditing = true;
          }
        });
    }
  }

  private onUpdatePoLineSuccess(message?: string) {
    this.toastr.success(message, 'Po Line Number Updated!!!', {
      timeOut: 800,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdatePoLineError(errorMessage: string) {
    this.toastr.error(errorMessage, 'Error!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  dismissWarningMessages(){
    this.warningMessagesList = [];
    this.warningMessages$.next(undefined);
  }

  dismissErrorMessages(){
    this.errorMessagesList = [];
    this.errorMessages$.next(undefined);
  }

  findIncompatibleSkus(groupingCategory: string) {
    let incompatibleSkusInPurchasePlan: string[] = [];
    if (groupingCategory !== undefined && groupingCategory != null && groupingCategory === "GSA_CONTRACTS") {
        if (this.getOrderSimulationResponse() !== undefined &&
            this.getOrderSimulationResponse().orderLines != null &&
            this.getOrderSimulationResponse().orderLines.length > 0) {
            incompatibleSkusInPurchasePlan = this.getOrderSimulationResponse()
                .orderLines.filter(item => !item.purchaseplanprice).map(item => item.sku);
            if (incompatibleSkusInPurchasePlan.length > 0) {
                this.incompatibleSkus = incompatibleSkusInPurchasePlan;
                this.incompatibleSkusToBeDeleted = this.incompatibleSkus;
                this.worksheetContinueFlag.emit(false);
                const uniqueSkus = new Set(incompatibleSkusInPurchasePlan);
               let errorMsgStr = "The cart contains incompatible item (SKU # " + Array.from(uniqueSkus).join(", ") + ")."
                             +" Please delete the mentioned items or select other purchase plan.";
                this.pushErrorMessagesIntoArray(errorMsgStr);
                this.loadErrorMessages();
            }
        }
    }
 }

  loadAllWarningMessages() {
    this.getHazmatSkus();
  }

moveBomRowsUp() {
  if (this.type == 'bom' && this.bomItemsSelectedIds && this.bomItemsSelectedIds.length) {
    this.isBomItemsMoved = true;
    let lowestIndex: number = -1;
    let currentIndex: number = -1;    
    this.bomItemsSelectedIds.forEach(blId => {
      currentIndex = this.bomItemsToShow.filter(bItem => bItem.line.id == blId)[0].line.index;
      if (lowestIndex == -1 || currentIndex < lowestIndex) {
        lowestIndex = currentIndex;
      }
    });
    if (lowestIndex > ((this.page-1) * this.pageSize) ) {
      let bomLineIdsAlreadyMoved: string[] = [];
      this.bomItemsSelectedIds.forEach(blId => {
        if (!bomLineIdsAlreadyMoved.includes(blId)) {
          bomLineIdsAlreadyMoved.push(blId);
          let bomTableRowindex: number = -1;
          let bomTableRow: BomTableRow;
          let prevBomTableRow: BomTableRow;
          let consecutiveSelectedRows: number = 1;
          bomTableRow = this.bomItemsToShow.filter(bItem => bItem.line.id == blId)[0];
          bomTableRowindex = bomTableRow.line.index;
          prevBomTableRow = this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))-1];
          while (this.bomItemsSelectedIds.includes(prevBomTableRow.line.id)) {
            consecutiveSelectedRows+=1;
            bomLineIdsAlreadyMoved.push(prevBomTableRow.line.id);
            bomTableRow = this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))-1];
            prevBomTableRow = this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))-2];
            bomTableRowindex = bomTableRowindex-1;
          }
          
          while (consecutiveSelectedRows > 0) {
            consecutiveSelectedRows-=1;
            bomTableRow.line.index = bomTableRowindex-1;
            this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))-1] = bomTableRow;
            if (consecutiveSelectedRows > 0) {
              bomTableRow = this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))+1];
              bomTableRowindex = bomTableRow.line.index;
            }
          }
          prevBomTableRow.line.index = bomTableRowindex;
          this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))] = prevBomTableRow;
        }
        
      });
    }
  }
}

moveBomRowsDown() {
  if (this.type == 'bom' && this.bomItemsSelectedIds && this.bomItemsSelectedIds.length) {
    this.isBomItemsMoved = true;
    let highestIndex: number = -1;
    let currentIndex: number = -1;
    this.bomItemsSelectedIds.forEach(blId => {
      currentIndex = this.bomItemsToShow.filter(bItem => bItem.line.id == blId)[0].line.index;
      if (highestIndex == -1 || currentIndex > highestIndex) {
        highestIndex = currentIndex;
      }
    });
    if ( (highestIndex-((this.page - 1) * this.pageSize))+1 < this.bomItemsToShow.length ) {
      let bomLineIdsAlreadyMoved: string[] = [];
      this.bomItemsSelectedIds.forEach(blId => {
        if (!bomLineIdsAlreadyMoved.includes(blId)) {
          bomLineIdsAlreadyMoved.push(blId);
          let bomTableRowindex: number = -1;
          let bomTableRow: BomTableRow;
          let nextBomTableRow: BomTableRow;
          let consecutiveSelectedRows: number = 1;
          bomTableRow = this.bomItemsToShow.filter(bItem => bItem.line.id == blId)[0];
          bomTableRowindex = bomTableRow.line.index;
          nextBomTableRow = this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))+1];
          while (this.bomItemsSelectedIds.includes(nextBomTableRow.line.id)) {
            consecutiveSelectedRows+=1;
            bomLineIdsAlreadyMoved.push(nextBomTableRow.line.id);
            bomTableRow = this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))+1];
            nextBomTableRow = this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))+2];
            bomTableRowindex = bomTableRowindex+1;
          }
          
          while (consecutiveSelectedRows > 0) {
            consecutiveSelectedRows-=1;
            bomTableRow.line.index = bomTableRowindex+1;
            this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))+1] = bomTableRow;
            if (consecutiveSelectedRows > 0) {
              bomTableRow = this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))-1];
              bomTableRowindex = bomTableRow.line.index;
            }
          }
          nextBomTableRow.line.index = bomTableRowindex;
          this.bomItemsToShow[(bomTableRowindex-((this.page-1) * this.pageSize))] = nextBomTableRow;
        }
        
      });
    }
  }
}

reorderBomLines() {
  let bomlineInputList: BomLineInput[] = [];
  this.bomItemsToShow.forEach(bi => {
    let bomLineInput: BomLineInput = new BomLineInput();
    bomLineInput.bomId = this.bomId;
    bomLineInput.bomLineId = bi.line.id;
    bomLineInput.index = bi.line.index;
    bomlineInputList.push(bomLineInput);
  });
  if(bomlineInputList.length > 0){
    this.projectService.updateBomLinesIndex(bomlineInputList).subscribe((items) => {
      this.unselectAllItems();
      this.setData(items);
      this.onUpdateBomLineSuccess("");
    }, error => {
      this.onUpdateBomLineError("Bom Lines update failed");
    });
  } else {
    this.showWarningMsg('No items to save.');
  }
}

updateSectionHeader() {
  this.$sectionHeaderSubject
  .debounceTime(1000)
  .distinctUntilChanged()
  .subscribe((data: [BomTableRow, HTMLInputElement]) => {
    const row = data[0];
    const input = data[1];
    let alc = String(input.value);
    const model = this.bomItems.find(i => i.line.id === row.line.id);
    if (this.type === 'worksheet') {
      this.bomItems.find(i => i.line.id === row.line.id).line.sectionHeader = alc;
      model.line.sectionHeader = row.line.sectionHeader = alc;
      let message;
      this.projectService.updateBomLine(this.bomId, model.line).subscribe(lines => {
        this.bomTableService.addWaitingQuoteItems([model.line.id]);
        lines.forEach(
          line => {
            if(line.isNew) {
              this.bomTableService.toTableBomRowsV2(lines, this.accountNumber, this.orgId)
                .subscribe(rows => { 
                  this.bomItems.push(rows[0]);
                  this.bomItemsToShow.push(rows[0]);
                  message = line.message ? line.message : message;
                });                    
            } else {
              this.bomItems.find(i => i.line.id === line.id).line.quantity = line.quantity;
              message = line.message ? line.message : message;
            }
          }
        );
        this.onUpdateBomLineSuccess(message);
      }, error => {
        this.onUpdateBomLineError(error.error.message);
      });
    } else if (this.type === 'bom') {
      if (model) {
        model.line.sectionHeader = row.line.sectionHeader = alc;
        if (this.edit === true) {
          this.projectService.updateBomLine(this.bomId, model.line).subscribe(lines => {
            this.emitRowsChange();
          });
        } else {
          this.emitRowsChange();
        }
      }
    }
  });
}

  onChangeQuantity(bomLineId: string) {
    this.qtyEditingFlag = false;
    this.bomLineID = bomLineId;
  }

  onChangePOLineNumber(bomLineId: string, poLineNumber: number) {
    if(!this.isBulkPOLineNumberUpdationReqd){
      this.poLineEditing = false;
      this.bomLineID = bomLineId;
    }
    
    if (!isNaN(poLineNumber)) {
      this.setBOMLinesPOLineNumber(bomLineId, poLineNumber);
      this.poLineNumberDetails.emit(this.bomLineAndItsPOLineNumbers);
    }
  }

  populatePOLineNumbesForAllBOMLines() {
    this.bomItemsToShow.forEach(bomItems => {
      let poLineNumber = bomItems.line.poLineNumber;
      let bomLineId = bomItems.line.id;
      this.setBOMLinesPOLineNumber(bomLineId, poLineNumber);
    });
  }

  private setBOMLinesPOLineNumber(bomLineId: string, poLineNumber: number) {
    const index = this.bomLineAndItsPOLineNumbers.findIndex(adv => adv.bomLineId === bomLineId);
    if (index === -1) {
      let bomLineVal = new BomLineInput();
      bomLineVal.bomLineId = bomLineId;
      bomLineVal.poLineNumber = Number(poLineNumber);
      bomLineVal.bomId = this.bomId;
      this.bomLineAndItsPOLineNumbers.push(bomLineVal);
    } else {
      let bomLineVal = new BomLineInput();
      bomLineVal.bomLineId = bomLineId;
      bomLineVal.poLineNumber = Number(poLineNumber);
      bomLineVal.bomId = this.bomId;
      this.bomLineAndItsPOLineNumbers[index] = bomLineVal;
    }
  }

  private getMinQtyAdjustedSKUMessage(minOrderQty: number, sku: string): string {
    let adjustedSkuWarningMsg:string = 'The quantity was adjusted to ' + minOrderQty + ' to meet the minimum quantity' +
      ' required for SKU ' + sku;
    return adjustedSkuWarningMsg;
  }

  private pushErrorMessagesIntoArray(message: string): void {
    if (this.errorMessagesList.indexOf(message) == -1) {
      this.errorMessagesList.push(message);
    }
  }

  private pushWarningMessagesIntoArray(message: string): void {
    if (this.warningMessagesList.indexOf(message) == -1) {
      this.warningMessagesList.push(message);
    }
  }

  private loadWarningMessages(): void {
    this.warningMessages$.next(undefined);
    this.warningMessages$.next(this.warningMessagesList);
  }

  private loadErrorMessages(): void {
    this.errorMessages$.next(undefined);
    this.errorMessages$.next(this.errorMessagesList);
  }

  filterByStatus(status: string) {
    this.showFilterTypes = true;
    this.currentStatusFilter = status;
    this.loading = true;
    this.pageSize = status == 'PAGINATED' ? 50 : 2000;
    this.loadPage(1);
  }

  onPaste(event: any) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    // Regular expression to match a number between 1 and 999999
    const regex = /^(?:[1-9]\d{0,5})$/;
    if (!regex.test(pastedText.trim())) {
      event.target.value = '';// Prevent the paste action if it doesn't match the regex
    }
  }

  validateInput(event: KeyboardEvent): boolean {
    const key = event.key;
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value + key;
    const numericRegex = /^(?:[1-9]\d{0,5})$/;
    // Check if the input is a valid number
    if (!numericRegex.test(inputValue) || inputValue === '0' || parseInt(inputValue, 10) > 999999) {
      event.preventDefault(); // Prevent the keypress event
      return false;
    }
    return true;
  }

  getDate(backorderAvailabilities: any){
    if (backorderAvailabilities && backorderAvailabilities.length) {
      var estDate = backorderAvailabilities[0].estimatedStockingDate;
      return estDate.slice(0,4) + '-' + estDate.slice(4,6) + '-' + estDate.slice(6,8);
    }
  }

  public sanitizeUrls(text: string): any {
    const urlRegex = /(((http?:\/\/)|(https?:\/\/)|(www\.))[^\s]+)/g;
    return text.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/bom-table/bom-table.component.ts